module.exports = __webpack_public_path__ + "media/images/thumbs/anatomyphysiology/am619-41396e13493685fa8080069fe470ecda.jpg";